import React from 'react';

const PolitiqueConfidentialite: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-prudens-bleu-fonce to-gray-100 py-16 text-white">
        <div className="container-custom">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            Politique de confidentialité
          </h1>
          <p className="text-lg md:text-xl text-prudens-bleu-grise max-w-3xl">
            Comment Prudens collecte, utilise et protège vos données personnelles.
          </p>
        </div>
      </section>

      {/* Contenu principal */}
      <section className="py-12 bg-gray-100">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-8">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-2xl font-bold text-prudens-bleu-fonce">
                Politique de confidentialité — Prudens
              </h2>
            </div>
            <p className="text-sm text-gray-500 mb-8">Dernière mise à jour : 11 mai 2026</p>

            <div className="space-y-8 text-gray-700 text-sm md:text-base leading-relaxed">

              <section>
                <h3 className="text-lg md:text-xl font-semibold text-prudens-bleu-fonce mb-3">
                  1. Collecte des données
                </h3>
                <p className="mb-3">Prudens collecte les données suivantes :</p>
                <ul className="list-disc list-inside space-y-1">
                  <li>Nom et prénom</li>
                  <li>Adresse email</li>
                  <li>Données d'utilisation (connexions, messages, appels)</li>
                  <li>Données techniques (type d'appareil, version de l'app)</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg md:text-xl font-semibold text-prudens-bleu-fonce mb-3">
                  2. Utilisation des données
                </h3>
                <p className="mb-3">Ces données sont utilisées pour :</p>
                <ul className="list-disc list-inside space-y-1">
                  <li>Fournir le service de téléconcierge</li>
                  <li>Gérer votre compte et votre abonnement</li>
                  <li>Améliorer nos services</li>
                  <li>Vous contacter en cas de besoin</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg md:text-xl font-semibold text-prudens-bleu-fonce mb-3">
                  3. Partage des données
                </h3>
                <p className="mb-3">
                  Vos données ne sont jamais vendues à des tiers. Elles peuvent être partagées
                  uniquement avec :
                </p>
                <ul className="list-disc list-inside space-y-1">
                  <li>Les téléconcierges assignés à votre compte</li>
                  <li>Nos prestataires techniques (hébergement, Firebase)</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg md:text-xl font-semibold text-prudens-bleu-fonce mb-3">
                  4. Conservation des données
                </h3>
                <p>
                  Vos données sont conservées pendant toute la durée de votre abonnement, puis
                  supprimées dans un délai de 30 jours après résiliation.
                </p>
              </section>

              <section>
                <h3 className="text-lg md:text-xl font-semibold text-prudens-bleu-fonce mb-3">
                  5. Vos droits
                </h3>
                <p>
                  Conformément au RGPD, vous disposez des droits d'accès, de rectification et de
                  suppression de vos données. Pour exercer ces droits, contactez-nous à :{' '}
                  <a
                    href="mailto:tech@prudens-france.fr"
                    className="text-prudens-bleu-clair hover:text-prudens-bleu-fonce underline-offset-2 hover:underline"
                  >
                    tech@prudens-france.fr
                  </a>
                  .
                </p>
              </section>

              <section>
                <h3 className="text-lg md:text-xl font-semibold text-prudens-bleu-fonce mb-3">
                  6. Contact
                </h3>
                <address className="not-italic space-y-1">
                  <p className="font-semibold">Prudens</p>
                  <p>
                    <a
                      href="mailto:tech@prudens-france.fr"
                      className="text-prudens-bleu-clair hover:text-prudens-bleu-fonce underline-offset-2 hover:underline"
                    >
                      tech@prudens-france.fr
                    </a>
                  </p>
                  <p>
                    <a
                      href="https://www.prudens-france.fr"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-prudens-bleu-clair hover:text-prudens-bleu-fonce underline-offset-2 hover:underline"
                    >
                      www.prudens-france.fr
                    </a>
                  </p>
                </address>
              </section>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PolitiqueConfidentialite;
